import Vue from "vue";
import Router from "vue-router";
import Cookie from "../utils/cookie";
import EventBus from "../utils/eventBus";

// 页面
import index from "@/views/index";
import activitycenter from "@/views/activitycenter";
import productcenter from "@/views/productcenter";
import recruitment from "@/views/recruitment";
import aboutus from "@/views/aboutus";
import personal from "@/views/personal/index";
import inquiry from "@/views/personal/inquiry";
import deliver from "@/views/personal/deliver";
import order from "@/views/personal/order";
import orderDetail from "@/views/personal/order/detail";
import bill from "@/views/personal/bill";
import billDetail from "@/views/personal/bill/detail";
import flowingWater from "@/views/personal/flowingWater";
import cost from "@/views/personal/cost";

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

const beforeEnterGuard = (to, from, next) => {
  let loginedUser = sessionStorage.getItem("user");
  if (loginedUser) {
    loginedUser = JSON.parse(Cookie.getCookie(loginedUser));
  }
  if (!loginedUser) {
    EventBus.emit("showLogin");
    next({ name: "inquiry" });
  } else next();
};

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "index"
    },
    {
      path: "/index",
      name: "index",
      component: index
    },
    {
      path: "/activitycenter",
      name: "activitycenter",
      component: activitycenter
    },
    {
      path: "/productcenter",
      name: "productcenter",
      component: productcenter
    },
    {
      path: "/recruitment",
      name: "recruitment",
      component: recruitment
    },
    {
      path: "/aboutus",
      name: "aboutus",
      component: aboutus
    },
    {
      path: "/personal",
      name: "personal",
      component: personal,
      children: [
        {
          path: "inquiry",
          name: "inquiry",
          component: inquiry,
          beforeEnter: (to, from, next) => {
            if (to.query.nodump) return next();
            let loginedUser = sessionStorage.getItem("user");
            if (loginedUser) {
              loginedUser = JSON.parse(Cookie.getCookie(loginedUser));
            }
            if (loginedUser) return next();
            next();
            Vue.nextTick(() => EventBus.emit("showLogin"));
          }
        },
        {
          path: "deliver",
          name: "deliver",
          component: deliver,
          beforeEnter: beforeEnterGuard
        },
        {
          path: "order",
          name: "order",
          component: order,
          beforeEnter: beforeEnterGuard
        },
        {
          path: "orderDetail/:id",
          name: "orderDetail",
          component: orderDetail,
          beforeEnter: beforeEnterGuard
        },
        {
          path: "bill",
          name: "bill",
          component: bill,
          beforeEnter: beforeEnterGuard
        },
        {
          path: "bill-detail/:billNo",
          name: "billDetail",
          component: billDetail,
          beforeEnter: beforeEnterGuard
        },
        {
          path: "flowing-water",
          name: "flowingWater",
          component: flowingWater,
          beforeEnter: beforeEnterGuard
        },

        {
          path: "cost",
          name: "cost",
          component: cost,
          beforeEnter: beforeEnterGuard
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js